import angular from "angular";
import component from "./directions-control.component";

let mod = angular.module('DirectionsControl', [component]);

export default mod.name;




// WEBPACK FOOTER //
// ./resources/assets/modules/directions-control/directions-control.module.js